import styled from 'styled-components';

import { ButtonBase } from '@material-ui/core';

export const Container = styled(ButtonBase)`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #373737 !important;

  .informations {
    font-weight: 400;
    margin-left: 15px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .name {
      font-size: 13.5px;
    }
    .register {
      font-size: 11.5px;
    }
  }

  .avatar {
    width: 40px;
    height: 40px;
  }
`;
